import { ApiClient } from "../../types/domainobjects";
import type { BilbasenDealerMapResponse } from "../types/bilbasen-dealer-map-response";

const apiClient = new ApiClient();

const getClientInternals = () => {
  return apiClient as unknown as {
    baseUrl: string;
    http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  };
};

export const getBilbasenDealers = async (): Promise<BilbasenDealerMapResponse> => {
  const client = getClientInternals();
  const response = await client.http.fetch(
    `${client.baseUrl}/api/bilbasen-dealers`,
    {
      method: "GET",
      headers: { Accept: "application/json" }
    }
  );

  if (!response.ok) {
    throw new Error("Failed to load Bilbasen dealers.");
  }

  return await response.json() as BilbasenDealerMapResponse;
};

export const enqueueBilbasenDealerSync = async (): Promise<void> => {
  const client = getClientInternals();
  const response = await client.http.fetch(
    `${client.baseUrl}/api/bilbasen-dealers/sync`,
    {
      method: "POST",
      headers: { Accept: "application/json" }
    }
  );

  if (!response.ok) {
    throw new Error("Failed to start Bilbasen dealer sync.");
  }
};

export const enqueueBilbasenDealerWebsiteRescan = async (): Promise<void> => {
  const client = getClientInternals();
  const response = await client.http.fetch(
    `${client.baseUrl}/api/bilbasen-dealers/rescan-websites`,
    {
      method: "POST",
      headers: { Accept: "application/json" }
    }
  );

  if (!response.ok) {
    throw new Error("Failed to start Bilbasen dealer website rescan.");
  }
};
